<template>
    <div
        v-show="isShowModal"
        class="o-m-warning-modal"
    >
        <div class="warning-modal-container">
            <button
                type="button"
                class="warning-modal-button"
                @click="closeModal"
            />
            <span class="warning-modal-content">
                {{ $t(config.content) }}
            </span>
            <AButton
                v-if="config.submitButton"
                :text="$t('ui.proceed')"
                class="submit-button"
                theme="dark"
                @onClick="onProceed"
            /> 
        </div>
    </div>
</template>

<script>
import AButton from '../../atoms/a-button/a-button';

import { DEFAULT_CONFIG } from "./constants";
import {
    EVENTS,
    SHOW_WARNING_MODAL
} from '../../../utils/constants/bus-events-constants';

export default {
    name: 'OMWarningModal',
    components: {
        AButton
    },
    data() {
        return {
            isShowModal: false,
            config: {
                content: DEFAULT_CONFIG
            }
        }
    },
    mounted() {
        this.initListeners();
    },
    beforeDestroy() {
        this.deactivateListeners();
    },
    methods: {
        initListeners() {
            this.$bus.$on(SHOW_WARNING_MODAL, this.showModal);
        },
        deactivateListeners() {
            this.$bus.$off(SHOW_WARNING_MODAL, this.showModal);
        },
        showModal(config) {
            this.isShowModal = true;
            this.config = {
                ...this.config,
                ...config
            };
        },
        closeModal() {
            this.isShowModal = false;
            this.config = DEFAULT_CONFIG;
        },
        onProceed() {
            this.$bus.$emit(EVENTS.MODALS.PROCEED_TO_REQUEST_PERMISSIONS);
            this.closeModal();
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />